import { render, staticRenderFns } from "./priceEdit.vue?vue&type=template&id=0428362e&scoped=true&"
import script from "./priceEdit.vue?vue&type=script&lang=js&"
export * from "./priceEdit.vue?vue&type=script&lang=js&"
import style0 from "./priceEdit.vue?vue&type=style&index=0&id=0428362e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428362e",
  null
  
)

export default component.exports